import { z } from 'zod';
import { MANDATORY_FIELD } from 'config/zodConfig';

export const ResponsibleInviteFormSchema = z.object({
  studentIds: z.number().array().min(1, { message: MANDATORY_FIELD }),
  facialControllerIds: z.number().array().default([]),
  deviceGroupIds: z.number().array().default([]),
  uc: z.string().array().default([]),
  expiresInDays: z
    .number({ message: MANDATORY_FIELD })
    .min(1, { message: 'O prazo mínimo é de 1 dia.' })
    .max(365, { message: 'O prazo máximo é de 365 dias.' }),
});

const ONLY_DIGITS_REGEX = /\D/g;

const isValidCpf = (rawCpf: string): boolean => {
  const cpf = rawCpf.replace(ONLY_DIGITS_REGEX, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const digits = cpf.split('').map(Number);
  const calcCheckDigit = (length: number): number => {
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += digits[i] * (length + 1 - i);
    }
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  return calcCheckDigit(9) === digits[9] && calcCheckDigit(10) === digits[10];
};

export const PublicResponsibleInviteFormSchema = z.object({
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z
    .string()
    .nonempty({ message: MANDATORY_FIELD })
    .refine(isValidCpf, { message: 'CPF inválido.' }),
  phone: z.string().optional(),
  email: z
    .string()
    .nonempty({ message: MANDATORY_FIELD })
    .email({ message: 'E-mail inválido.' }),
});
